import React, { useEffect, useState } from "react";
import { getCOI, getTeam } from "../../lib/api";
import { pdfjs, Document, Page } from "react-pdf";
import { GetObjectCommand, S3Client } from "@aws-sdk/client-s3";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-providers";
import { AWS_REGION, UPLOADED_COI_URL } from "../../lib/globals";
import { useLoaderData, useNavigate } from "react-router";
import { ICOIInfo } from "../../types/api";
import { FetchHttpHandler } from "@smithy/fetch-http-handler";
import { Link } from "react-router-dom";
import { Container } from "react-bootstrap";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

// const s3Client = new S3Client({
//     region: AWS_REGION,
//     credentials: fromCognitoIdentityPool({
//         clientConfig: { region: AWS_REGION },
//         identityPoolId: "us-east-1:d82c2669-6e63-4635-b4bc-3e4c39479f32",
//     }),
//     requestHandler: new FetchHttpHandler({ keepAlive: false }),
// });

export const loader = async ({ params }: any) => {
    const { teamId } = params;
    const [{ coi }, { team }] = await Promise.all([
        getCOI(teamId),
        getTeam(teamId),
    ]);

    return {
        teamId,
        coi: coi[0],
        header: `COI Approvals / ${team.name}`,
    };
};

const COI = (): React.JSX.Element => {
    const [pageNumber, setPageNumber] = useState<number>(1);
    const { coi } = useLoaderData() as { coi: ICOIInfo };
    const navigate = useNavigate();

    const getFileType = (fileName: string) => {
        const parts = fileName.split(".");
        const extension = parts[parts.length - 1].toLowerCase();

        switch (extension) {
            case "png":
                return "PNG";
            case "pdf":
                return "PDF";
            default:
                return "Unknown";
        }
    };
    // useEffect(() => {
    //     const getFile = async () => {
    //         const command = new GetObjectCommand({
    //             Bucket: "baseball365-dev-files.coi",
    //             Key: `${coi.file}`,
    //         });

    //         try {
    //             const response = await s3Client.send(command);
    //             const str = await response.Body?.transformToString();
    //             console.log(str);
    //         } catch (err) {
    //             console.error(err);
    //         }
    //     };

    //     getFile();
    // }, [coi]);

    const displayCOI = (coi: ICOIInfo) => {
        const fileURL = `${UPLOADED_COI_URL}${coi.file}`;
        switch (getFileType(coi.file)) {
            case "PDF":
                return (
                    <Document file={fileURL} loading="Loading COI...">
                        <Page
                            pageNumber={pageNumber}
                            renderTextLayer={false}
                            renderAnnotationLayer={false}
                        />
                    </Document>
                );
            case "PNG":
                return <img className="img-fluid" src={fileURL} />;
            default:
                return <h4>Invalid COI type uploaded by user</h4>;
        }
    };

    return (
        <Container className="COIcontent" data-testid="COIcontent" fluid="xs">
            <Link
                to=".."
                onClick={e => {
                    e.preventDefault();
                    navigate(-1);
                }}
            >
                back to list
            </Link>
            {displayCOI(coi)}
        </Container>
    );
};

export default COI;
